import axios from "./axios"

export const logInRequest = async (data) => {
    const response = await axios.post('users/login', data, {withCredentials: true})
    return response.data
    
}

export const fetchAccountInfo = async (token) => {
    const response = await axios.get('users/me',
        {
            headers: { Authorization: `bearer ${token}` },
            withCredentials: true
        }
    )
    return response.data
}

export const fetchPersonalInfo = async (token) => {
    const response = await axios.get('persons/me',
        {
            headers: { Authorization: `bearer ${token}` },
            withCredentials: true
        }
    )
    return response.data
}
